import React, { Component } from 'react';
import './App.css';
import Slider from 'react-slick';
import { Link, DirectLink, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

const durationFn = function(deltaTop) {
    return deltaTop;
};


class Section_2 extends Component {

  constructor (props){
    super(props);
    this.scrollToTop = this.scrollToTop.bind(this);
}

scrollToTop() {
  scroll.scrollToTop();
}
scrollTo() {
  scroller.scrollTo('scroll-to-element', {
    duration: 800,
    delay: 0,
    smooth: 'easeInOutQuart'
  })
}
scrollToWithContainer() {

  let goToContainer = new Promise((resolve, reject) => {

    Events.scrollEvent.register('end', () => {
      resolve();
      Events.scrollEvent.remove('end');
    });

    scroller.scrollTo('scroll-container', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    });

  });

  goToContainer.then(() =>
      scroller.scrollTo('scroll-container-second-element', {
          duration: 800,
          delay: 0,
          smooth: 'easeInOutQuart',
          containerId: 'scroll-container'
      }));
}
componentWillUnmount() {
  Events.scrollEvent.remove('begin');
  Events.scrollEvent.remove('end');
}


  render() {

    return (
      <section className="section_2">
        <header>
          <div className="menu_container">
            <div>
              <Link to="food" smooth={true} duration={500} >
                <img src="http://res.cloudinary.com/dhs8w3df1/image/upload/v1512598772/shape_o36cba.svg" />
                <img src="http://res.cloudinary.com/dhs8w3df1/image/upload/v1512598782/letter_gwh5j3.svg" />
              </Link>
            </div>
            <div>
              <Link to="story" smooth={true} duration={1000} >
                <img src="http://res.cloudinary.com/dhs8w3df1/image/upload/v1512598883/shape_itusth.svg" />
                <img src="http://res.cloudinary.com/dhs8w3df1/image/upload/v1512598890/letter_clspzj.svg" />
              </Link>
            </div>
            <div>
              <Link to="contact" smooth={true} duration={1200} >
                <img src="http://res.cloudinary.com/dhs8w3df1/image/upload/v1512598948/shape_hsvdwz.svg" />
                <img src="http://res.cloudinary.com/dhs8w3df1/image/upload/v1512599028/letter_ig1jrs.svg" />
              </Link>
            </div>
          </div>
        </header>

        <section className="heading_container">
          <h1>LEV is about creating events and culinary experiences that are dynamic and different each time. We use space, people and energy surrounding to inspire our cooking.</h1>
        </section>

        <section className="text_container">
          <div className="first_col">
              <div>
              <div className='slider'>
                <div className='slide1'>
                  <img src="https://res.cloudinary.com/dzzgflvyp/image/upload/v1688492508/LEV/slider_2/1800_5.jpg"></img>
                </div>
                <div className='slide2'>
                    <img src="https://res.cloudinary.com/dzzgflvyp/image/upload/v1688492508/LEV/slider_2/1800_6.jpg"></img>
                </div>
                <div className='slide3'>
                    <img src="https://res.cloudinary.com/dzzgflvyp/image/upload/v1688492508/LEV/slider_2/1800_7.jpg"></img>
                </div>
                <div className='slide4'>
                    <img src="https://res.cloudinary.com/dzzgflvyp/image/upload/v1688492508/LEV/slider_2/1800_8.jpg"></img>
                </div>
              </div>
              </div>
          </div>
          <div className="second_col">
            <p>
                  We cook in different locations, adapting the food to fit the setting. Whether that’s outside in a field, on a nyc sidewalk or the intimate setting of your home, you get food that is personal to match a unique experience.
            </p>
          </div>
        </section>


      </section>
    );
  }
}

export default Section_2;



// WEBPACK FOOTER //
// ./src/Section_2.js